import { render, staticRenderFns } from "./MspRisultatoItem.vue?vue&type=template&id=2d15b25b"
import script from "./MspRisultatoItem.vue?vue&type=script&lang=js"
export * from "./MspRisultatoItem.vue?vue&type=script&lang=js"
import style0 from "./MspRisultatoItem.vue?vue&type=style&index=0&id=2d15b25b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports